var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 5.48828V18.6914C17.2266 19.4023 16.6523 19.9766 15.9414 19.9766H4.05859C3.34766 19.9766 2.77344 19.4023 2.77344 18.6914V1.30859C2.77344 0.597656 3.34766 0.0234375 4.05859 0.0234375H11.7617L17.2266 5.48828Z",
    fill: "#23A566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1602 9.95703H6.83984C6.61328 9.95703 6.42969 10.1406 6.42969 10.3672V15.8711C6.42969 16.0977 6.61328 16.2812 6.83984 16.2812H13.1641C13.3906 16.2812 13.5742 16.0977 13.5742 15.8711V10.3711C13.5703 10.1445 13.3867 9.95703 13.1602 9.95703ZM7.25 12.5977H9.58984V13.6406H7.25V12.5977ZM10.4102 12.5977H12.75V13.6406H10.4102V12.5977ZM12.75 11.7773H10.4102V10.7813H12.75V11.7773ZM9.58984 10.7813V11.7773H7.25V10.7813H9.58984ZM7.25 14.4648H9.58984V15.4609H7.25V14.4648ZM10.4102 15.4609V14.4648H12.75V15.4609H10.4102Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M12.4961 5.28906L17.2266 9.12109V5.52344L14.543 3.96484L12.4961 5.28906Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 5.48828H13.0469C12.3359 5.48828 11.7617 4.91406 11.7617 4.20312V0.0234375L17.2266 5.48828Z",
    fill: "#8ED1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.acfdd652d632b0c64621bf2a4aafb895.svg";
export { ForwardRef as ReactComponent };